module.exports = "<app-invoice-list></app-invoice-list>\r\n"